
import {
  TInstallmentFees,
  TInstallmentFeesResponse,
  TPaymentOptionRequest,
  TUpdatePaymentOptionRequest,
} from "../../../coreGlobal/models/paymentOption";

// O formulário exibe as taxas pela posição no array, então precisam estar ordenadas por parcela
export const mapInstallmentFees = (fees?: TInstallmentFeesResponse[]): TInstallmentFees[] => {
    return [...(fees ?? [])]
        .sort((a, b) => a.installmentNumber - b.installmentNumber)
        .map((fee) => ({installment: fee.installmentNumber, percentage: fee.feePercentage}))
}

export const buildCreateRequest = (data: TPaymentOptionRequest)  => {
    return {
        name: data.name,
        category: data.category,
        franchise: data.franchise ?? null,
        installmentEnabled: data?.installmentEnabled,
        maxInstallments: data?.maxInstallments,
        installmentFees: data?.installmentFees
    }
}

export const buildUpdateRequest = (data: TUpdatePaymentOptionRequest)  => {
    return {
        name: data.name,
        category: data.category,
        franchise: data.franchise ?? null,
        active: data.active,
        installmentEnabled: data?.installmentEnabled,
        maxInstallments: data?.maxInstallments,
        installmentFees: data?.installmentFees

    }
}
